import {
    CREATE_TEAM_DETAILS_FAILURE,
    CREATE_TEAM_DETAILS_REQUEST,
    CREATE_TEAM_DETAILS_SUCCESS,
    CREATE_USER_FORM_TEAM_DETAILS,
    DELETE_TEAM_DETAILS_FAILURE,
    DELETE_TEAM_DETAILS_REQUEST,
    DELETE_TEAM_DETAILS_SUCCESS,
    FETCH_SINGLE_TEAM_DETAILS_FAILURE,
    FETCH_SINGLE_TEAM_DETAILS_REQUEST,
    FETCH_SINGLE_TEAM_DETAILS_SUCCESS,
    FETCH_TEAM_DETAILS_EMPLOYEE_LIST_FAILURE,
    FETCH_TEAM_DETAILS_EMPLOYEE_LIST_REQUEST,
    FETCH_TEAM_DETAILS_EMPLOYEE_LIST_SUCCESS,
    FETCH_TEAM_DETAILS_FAILURE,
    FETCH_TEAM_DETAILS_REQUEST,
    FETCH_TEAM_DETAILS_ROLE_FAILURE,
    FETCH_TEAM_DETAILS_ROLE_REQUEST,
    FETCH_TEAM_DETAILS_ROLE_SUCCESS,
    FETCH_TEAM_DETAILS_SUCCESS,
    TEAM_DETAILS_USERFORM_RESET,
    UPDATE_TEAM_DETAILS_FAILURE,
    UPDATE_TEAM_DETAILS_REQUEST,
    UPDATE_TEAM_DETAILS_SUCCESS
} from './teamDetails.actionsType';

export const TEAM_DETAILS = 'teamDetails';

let initialState = {
    loading: false,
    teamDetailsById: [],
    employeeList: [],
    RoleInTeamList: [],
    userform: {},
    selectedTeamDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let teamDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_TEAM_DETAILS_REQUEST:
        case FETCH_TEAM_DETAILS_EMPLOYEE_LIST_REQUEST:
        case FETCH_TEAM_DETAILS_ROLE_REQUEST:
        case CREATE_TEAM_DETAILS_REQUEST:
        case FETCH_SINGLE_TEAM_DETAILS_REQUEST:
        case UPDATE_TEAM_DETAILS_REQUEST:
        case DELETE_TEAM_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_TEAM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                teamDetailsById: updatePayload
            };

        case FETCH_TEAM_DETAILS_EMPLOYEE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeList: updatePayload
            };

        case FETCH_TEAM_DETAILS_ROLE_SUCCESS:
            return {
                ...state,
                loading: false,
                RoleInTeamList: updatePayload
            };

        case CREATE_TEAM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_TEAM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeamDetails: updatePayload,
                userform: {
                    employee: updatePayload.fldFKEmployee,
                    designation: updatePayload.fldEmployeeDesgination,
                    roleInTeam: updatePayload.fldFKRolesInTeam
                }
            };
        case UPDATE_TEAM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeamDetails: {},
                userform: {}
            };
        case DELETE_TEAM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeList: [],
                RoleInTeamList: [],
                userform: {},
                selectedTeamDetails: {}
            };
        case FETCH_TEAM_DETAILS_FAILURE:
        case FETCH_SINGLE_TEAM_DETAILS_FAILURE:
        case FETCH_TEAM_DETAILS_EMPLOYEE_LIST_FAILURE:
        case FETCH_TEAM_DETAILS_ROLE_FAILURE:
        case CREATE_TEAM_DETAILS_FAILURE:
        case UPDATE_TEAM_DETAILS_FAILURE:
        case DELETE_TEAM_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_TEAM_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case TEAM_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {},
                selectedTeamDetails: {}
            };
        default:
            return state;
    }
};
